import * as React from 'react';

/**
 * @return {React.ReactElement}
 * @constructor
 */
export default function BurgerClose(): React.ReactElement {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1.70654" width="20.9994" height="2.41369" transform="rotate(45 1.70654 0)" fill="#E1E6EF"/>
      <rect y="14.9194" width="20.9994" height="2.41369" transform="rotate(-45 0 14.9194)" fill="#E1E6EF"/>
    </svg>
  );
}
